const DOCUMENT_TYPE = {
    DNI_ID: 1,
    RUC_ID: 2,
    PASSPORT_ID: 3,
    CE_ID: 4,
    PTP_ID: 5,
};

export default DOCUMENT_TYPE